
class JsonApi {

    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }

    get(path, successFunction, errorFunction) {
        fetch(this.baseUrl + path, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'apikey': 'public'
            }
        })
            .then(response => {
                if (!response.ok) {
                    console.log("Network error");
                    return {status: 'error', message: 'Nätverksfel'};
                }
                return response.json()
            })
            .then(data => {
                if (data.status === 'success') {
                    successFunction(data);
                }
                else if (errorFunction != null) {
                    errorFunction(data);
                }

                },
                error => {
                    console.log("failing fetch");
                    console.log(error)
                    if (errorFunction != null) {
                        errorFunction(error);
                    }
                })
            .catch(error => {
            if (error instanceof TypeError && error.message.includes('API key')) {
                console.error('Invalid API key:', error);
            } else {
                console.error('There was a problem with the Fetch operation:', error);
            }
            if (errorFunction != null) {
                errorFunction({status: 'error', message: 'Nätverksfel! (' + error.message + ')'});
            }
        });

    }

    post(path, data, successFunction, errorFunction) {
        fetch(this.baseUrl + path, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'apikey': 'public'
            },
            body: JSON.stringify(data)
        })
            .then(response => {
                    if (!response.ok) {
                        return {status: 'error', message: 'Network error'};
                    }
                    return response.json()
                }
            )
            .then(data => {
                if (data.status === 'success') {
                    successFunction(data);
                }
                else if (errorFunction != null) {
                    errorFunction(data);
                }

            })
            .catch(error => {
                if (error instanceof TypeError && error.message.includes('API key')) {
                    console.error('Invalid API key:', error);
                } else {
                    console.error('There was a problem with the Fetch operation:', error);
                }
                if (errorFunction != null) {
                    errorFunction({status: 'error', message: 'Nätverksfel! (' + error.message + ')' });
                }
            });


    }

}

export default JsonApi;